<template lang="html">
  <v-container fluid>
    <v-row class="mb-2" align="center">
      <v-col cols="12" sm="8">
        <h2 class="headline font-weight-bold primary--text mb-0">Review Riwayat Kompetensi</h2>
        <div v-if="!loading && items.length" class="body-2 grey--text mt-1">
          Jumlah Soal: {{ items.length }}
        </div>
      </v-col>
      <v-col cols="12" sm="4" class="d-flex justify-sm-end">
        <v-btn outlined color="primary" @click="goBack">
          <v-icon left>mdi-arrow-left</v-icon>
          Kembali
        </v-btn>
      </v-col>
    </v-row>

    <v-skeleton-loader v-if="loading" type="article, list-item@6" class="mx-auto" max-width="900" />

    <v-row v-else-if="items.length" justify="center">
      <v-col cols="12" sm="3" md="2" class="d-flex justify-center justify-sm-end">
        <question-navigator
          :total="items.length"
          :current-index="currentIndex"
          :statuses="statuses"
          @navigate="goTo"
        />
      </v-col>

      <v-col cols="12" sm="9" md="10" lg="8">
        <v-card>
          <v-card-title class="d-flex flex-column align-start pb-1">
            <div class="caption grey--text mb-1">
              Pertanyaan {{ currentIndex + 1 }} / {{ items.length }}
            </div>
            <div class="primary--text text-uppercase font-weight-bold">
              {{ (currentItem.master_soal && currentItem.master_soal.kompetensi) || '-' }}
            </div>
          </v-card-title>

          <v-card-text>
            <div class="mb-4 text-body-1" style="line-height: 1.6;">
              {{ (currentItem.master_soal && currentItem.master_soal.soal) || '-' }}
            </div>

            <v-list dense class="pa-0">
              <v-list-item
                v-for="p in ((currentItem.master_soal && currentItem.master_soal.pilihan) || [])"
                :key="p.id"
                :class="{ 'selected-answer': isSelected(currentItem, p.id) }"
                class="option-item mb-2"
              >
                <v-list-item-icon class="mr-3 align-self-center">
                  <v-icon :color="isSelected(currentItem, p.id) ? 'primary' : 'grey lighten-1'">
                    {{ isSelected(currentItem, p.id) ? 'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}
                  </v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title
                    class="text-body-2"
                    style="white-space: normal; line-height: 1.45;"
                    :class="{ 'primary--text font-weight-medium': isSelected(currentItem, p.id) }"
                  >
                    {{ p.pilihan }}
                  </v-list-item-title>
                </v-list-item-content>
                <v-list-item-action v-if="isSelected(currentItem, p.id)">
                  <v-chip small color="primary" text-color="white">Jawaban Anda</v-chip>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card-text>

          <v-card-actions class="px-4 pb-4 flex-wrap">
            <v-btn
              outlined
              color="primary"
              :disabled="currentIndex === 0"
              @click="prev"
            >
              <v-icon left>mdi-chevron-left</v-icon>
              Sebelumnya
            </v-btn>

            <v-spacer />

            <v-btn
              color="primary"
              :disabled="isLast"
              @click="next"
            >
              Berikutnya
              <v-icon right>mdi-chevron-right</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>

    <v-alert v-else type="warning" prominent>
      Data detail riwayat kompetensi tidak ditemukan.
    </v-alert>
  </v-container>
</template>

<script>
import store from '@/store'
import KuesionerService from '@/services/KuesionerService'
import QuestionNavigator from './components/QuestionNavigator'

export default {
  name: 'ReviewHistoryKompetensi',
  components: {
    QuestionNavigator
  },
  data() {
    return {
      loading: true,
      items: [],
      currentIndex: 0
    }
  },
  computed: {
    currentItem() {
      return this.items[this.currentIndex] || {}
    },
    isLast() {
      return this.currentIndex >= this.items.length - 1
    },
    statuses() {
      return this.items.map(() => 'answered')
    }
  },
  created() {
    this.fetchDetail()
  },
  methods: {
    fetchDetail() {
      const id = this.$route.params.id
      this.loading = true
      KuesionerService.getDetailHasilKompetensi(id)
        .then(res => {
          this.items = (res.data && res.data.data) || []
          this.currentIndex = 0
        })
        .catch(err => {
          const message = (err.response && err.response.data && err.response.data.message)
            || err.message
            || 'Gagal memuat detail riwayat kompetensi'
          store.commit('snackbar/setSnack', { message, color: 'error' })
          this.items = []
          this.currentIndex = 0
        })
        .finally(() => {
          this.loading = false
        })
    },
    goTo(index) {
      if (index < 0 || index >= this.items.length || index === this.currentIndex) return
      this.currentIndex = index
    },
    prev() {
      if (this.currentIndex > 0) {
        this.currentIndex -= 1
      }
    },
    next() {
      if (this.currentIndex < this.items.length - 1) {
        this.currentIndex += 1
      }
    },
    isSelected(item, pilihanId) {
      return item.pilihan_id === pilihanId
        || (item.pilihan && item.pilihan.id === pilihanId)
    },
    goBack() {
      this.$router.push('/review-kompetensi')
    }
  }
}
</script>

<style scoped>
.option-item {
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 4px;
  min-height: 48px;
}
.selected-answer {
  border-color: var(--v-primary-base, #1976d2);
  background-color: rgba(25, 118, 210, 0.06);
}
</style>
